import React, { useContext, useState } from 'react';
import { createContext } from 'react';

interface AuthenticationType {
  token: string | null;
  role: string | null;
  userID: string | null;
  department: string | null;
  name: string | null; 
  login: (
    token: string,
    role: string,
    department: string,
    userID: string,
    name: string 
  ) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthenticationType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState(sessionStorage.getItem('token'));
  const [role, setRole] = useState(sessionStorage.getItem('role'));
  const [department, setDepartment] = useState(sessionStorage.getItem('department'));
  const [userID, setuserID] = useState(sessionStorage.getItem('userID'));
  const [name, setName] = useState(sessionStorage.getItem('name')); 

  const login = (
    token: string,
    role: string,
    userID: string,
    department: string,
    name: string 
  ) => {
    setToken(token);
    setRole(role);
    setuserID(userID);
    setDepartment(department);
    setName(name); 
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('role', role);
    sessionStorage.setItem('userID', userID);
    sessionStorage.setItem('department', department);
    sessionStorage.setItem('name', name); 
  };

  const logout = () => {
    setToken(null);
    setRole(null);
    setDepartment(null);
    setuserID(null);
    setName(null); 
    sessionStorage.clear();
  };

  return (
    <AuthContext.Provider
      value={{ token, role, department, userID, name, login, logout }} 
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('use within Auth Provider');
  return context;
};
